module.exports = Em.Handlebars.compile("<div>\n    {{info}}\n</div>\n");